// THIS IS LEGACY AND ONLY USED FOR THE OUTDATED ICON FONT
export const convertedIcons = {
    'adblue-alert': {
        large: '"\\EA01"',
        small: '"\\EA02"',
    },
    adblue: {
        large: '"\\EA03"',
        small: '"\\EA04"',
    },
    'address-book': {
        large: '"\\EA05"',
        small: '"\\EA06"',
    },
    administrator: {
        large: '"\\EA07"',
        small: '"\\EA08"',
    },
    'air-filter': {
        large: '"\\EA09"',
        small: '"\\EA0A"',
    },
    announcements: {
        large: '"\\EA0B"',
        small: '"\\EA0C"',
    },
    'anti-theft-alarm-system-alert': {
        large: '"\\EA0D"',
        small: '"\\EA0E"',
    },
    'anti-theft-alarm-system': {
        large: '"\\EA0F"',
        small: '"\\EA10"',
    },
    apps: {
        large: '"\\EA11"',
        small: '"\\EA12"',
    },
    'arrow-down': {
        large: '"\\EA13"',
        small: '"\\EA14"',
    },
    'arrow-left-light': {
        large: '"\\EA15"',
        small: '"\\EA16"',
    },
    'arrow-left-normal': {
        large: '"\\EA17"',
        small: '"\\EA18"',
    },
    'arrow-left-sharp': {
        large: '"\\EA19"',
        small: '"\\EA1A"',
    },
    'arrow-left-u-turn': {
        large: '"\\EA1B"',
        small: '"\\EA1C"',
    },
    'arrow-right-light': {
        large: '"\\EA1D"',
        small: '"\\EA1E"',
    },
    'arrow-right-normal': {
        large: '"\\EA1F"',
        small: '"\\EA20"',
    },
    'arrow-right-sharp': {
        large: '"\\EA21"',
        small: '"\\EA22"',
    },
    'arrow-right-u-turn': {
        large: '"\\EA23"',
        small: '"\\EA24"',
    },
    'arrow-straight-down': {
        large: '"\\EA25"',
        small: '"\\EA26"',
    },
    'arrow-straight-up': {
        large: '"\\EA27"',
        small: '"\\EA28"',
    },
    'arrow-up': {
        large: '"\\EA29"',
        small: '"\\EA2A"',
    },
    'audio-volume': {
        large: '"\\EA2B"',
        small: '"\\EA2C"',
    },
    aupeo: {
        large: '"\\EA2D"',
        small: '"\\EA2E"',
    },
    back: {
        large: '"\\EA2F"',
        small: '"\\EA30"',
    },
    battery: {
        large: '"\\EA31"',
        small: '"\\EA32"',
    },
    'blog-post': {
        large: '"\\EA33"',
        small: '"\\EA34"',
    },
    'bonnet-open': {
        large: '"\\EA35"',
        small: '"\\EA36"',
    },
    bookmark: {
        large: '"\\EA37"',
        small: '"\\EA38"',
    },
    'brake-fluid': {
        large: '"\\EA39"',
        small: '"\\EA3A"',
    },
    'brake-pad-alert': {
        large: '"\\EA3B"',
        small: '"\\EA3C"',
    },
    'brake-pad': {
        large: '"\\EA3D"',
        small: '"\\EA3E"',
    },
    break: {
        large: '"\\EA3F"',
        small: '"\\EA40"',
    },
    brush: {
        large: '"\\EA41"',
        small: '"\\EA42"',
    },
    'business-address': {
        large: '"\\EA43"',
        small: '"\\EA44"',
    },
    'business-customer': {
        large: '"\\EA45"',
        small: '"\\EA46"',
    },
    calculator: {
        large: '"\\EA47"',
        small: '"\\EA48"',
    },
    'calendar-events': {
        large: '"\\EA49"',
        small: '"\\EA4A"',
    },
    camera: {
        large: '"\\EA4B"',
        small: '"\\EA4C"',
    },
    cancel: {
        large: '"\\EA4D"',
        small: '"\\EA4E"',
    },
    'car-dimensions': {
        large: '"\\EA4F"',
        small: '"\\EA50"',
    },
    'car-handover': {
        large: '"\\EA51"',
        small: '"\\EA52"',
    },
    car: {
        large: '"\\EA53"',
        small: '"\\EA56"',
    },
    'car-search': {
        large: '"\\EA54"',
        small: '"\\EA55"',
    },
    catalogue: {
        large: '"\\EA57"',
        small: '"\\EA58"',
    },
    caution: {
        large: '"\\EA59"',
        small: '"\\EA5A"',
    },
    'charge-level': {
        large: '"\\EA5B"',
        small: '"\\EA5C"',
    },
    charging: {
        large: '"\\EA5D"',
        small: '"\\EA60"',
    },
    'charging-plate': {
        large: '"\\EA5E"',
        small: '"\\EA5F"',
    },
    'charging-station': {
        large: '"\\EA61"',
        small: '"\\EA62"',
    },
    city: {
        large: '"\\EA63"',
        small: '"\\EA64"',
    },
    'climate-auto': {
        large: '"\\EA65"',
        small: '"\\EA66"',
    },
    'climate-electric': {
        large: '"\\EA67"',
        small: '"\\EA68"',
    },
    climate: {
        large: '"\\EA69"',
        small: '"\\EA6A"',
    },
    clothing: {
        large: '"\\EA6B"',
        small: '"\\EA6C"',
    },
    'co2-emission': {
        large: '"\\EA6D"',
        small: '"\\EA6E"',
    },
    code: {
        large: '"\\EA6F"',
        small: '"\\EA70"',
    },
    'collapsed-tabs': {
        large: '"\\EA71"',
        small: '"\\EA72"',
    },
    commute: {
        large: '"\\EA73"',
        small: '"\\EA74"',
    },
    compare: {
        large: '"\\EA75"',
        small: '"\\EA76"',
    },
    compass: {
        large: '"\\EA77"',
        small: '"\\EA78"',
    },
    'connect-key': {
        large: '"\\EA79"',
        small: '"\\EA7A"',
    },
    consumption: {
        large: '"\\EA7B"',
        small: '"\\EA7C"',
    },
    'content-activities': {
        large: '"\\EA7D"',
        small: '"\\EA7E"',
    },
    copy: {
        large: '"\\EA7F"',
        small: '"\\EA80"',
    },
    country: {
        large: '"\\EA81"',
        small: '"\\EA82"',
    },
    'credit-card': {
        large: '"\\EA83"',
        small: '"\\EA84"',
    },
    'cross-traffic-assist-rear': {
        large: '"\\EA85"',
        small: '"\\EA86"',
    },
    'cubic-capacity': {
        large: '"\\EA87"',
        small: '"\\EA88"',
    },
    damper: {
        large: '"\\EA89"',
        small: '"\\EA8A"',
    },
    dashboard: {
        large: '"\\EA8B"',
        small: '"\\EA8C"',
    },
    'dealer-request': {
        large: '"\\EA8D"',
        small: '"\\EA8E"',
    },
    'dealer-search': {
        large: '"\\EA8F"',
        small: '"\\EA90"',
    },
    diagnostics: {
        large: '"\\EA91"',
        small: '"\\EA92"',
    },
    'direct-mail': {
        large: '"\\EA93"',
        small: '"\\EA94"',
    },
    discussion: {
        large: '"\\EA95"',
        small: '"\\EA96"',
    },
    display: {
        large: '"\\EA97"',
        small: '"\\EA98"',
    },
    distance: {
        large: '"\\EA99"',
        small: '"\\EA9A"',
    },
    'document-pdf': {
        large: '"\\EA9B"',
        small: '"\\EA9C"',
    },
    'document-pricelist-dollar': {
        large: '"\\EA9D"',
        small: '"\\EA9E"',
    },
    'document-pricelist-euro': {
        large: '"\\EA9F"',
        small: '"\\EAA0"',
    },
    'document-taxation': {
        large: '"\\EAA1"',
        small: '"\\EAA2"',
    },
    documents: {
        large: '"\\EAA3"',
        small: '"\\EAA4"',
    },
    'door-open': {
        large: '"\\EAA5"',
        small: '"\\EAA6"',
    },
    download: {
        large: '"\\EAA7"',
        small: '"\\EAA8"',
    },
    'drive-belt': {
        large: '"\\EAA9"',
        small: '"\\EAAA"',
    },
    'eco-cycle': {
        large: '"\\EAAB"',
        small: '"\\EAAC"',
    },
    'eco-friendly': {
        large: '"\\EAAD"',
        small: '"\\EAAE"',
    },
    edit: {
        large: '"\\EAAF"',
        small: '"\\EAB0"',
    },
    editorial: {
        large: '"\\EAB1"',
        small: '"\\EAB2"',
    },
    'electric-range': {
        large: '"\\EAB3"',
        small: '"\\EAB4"',
    },
    'energy-green': {
        large: '"\\EAB5"',
        small: '"\\EAB6"',
    },
    engine: {
        large: '"\\EAB7"',
        small: '"\\EAB8"',
    },
    erase: {
        large: '"\\EAB9"',
        small: '"\\EABA"',
    },
    'external-link': {
        large: '"\\EABB"',
        small: '"\\EABC"',
    },
    'eye-crossed': {
        large: '"\\EABD"',
        small: '"\\EABE"',
    },
    eye: {
        large: '"\\EABF"',
        small: '"\\EAC0"',
    },
    facebook: {
        large: '"\\EAC1"',
        small: '"\\EAC2"',
    },
    factory: {
        large: '"\\EAC3"',
        small: '"\\EAC4"',
    },
    'favorite-filled': {
        large: '"\\EAC5"',
        small: '"\\EAC6"',
    },
    favorite: {
        large: '"\\EAC7"',
        small: '"\\EAC8"',
    },
    'feature-on-demand': {
        large: '"\\EAC9"',
        small: '"\\EACA"',
    },
    feed: {
        large: '"\\EACB"',
        small: '"\\EACC"',
    },
    filter: {
        large: '"\\EACD"',
        small: '"\\EACE"',
    },
    'financial-services': {
        large: '"\\EACF"',
        small: '"\\EAD0"',
    },
    'first-aid': {
        large: '"\\EAD1"',
        small: '"\\EAD2"',
    },
    flashlight: {
        large: '"\\EAD3"',
        small: '"\\EAD4"',
    },
    forward: {
        large: '"\\EAD5"',
        small: '"\\EAD6"',
    },
    'fuel-range': {
        large: '"\\EAD7"',
        small: '"\\EAD8"',
    },
    'fuel-station': {
        large: '"\\EAD9"',
        small: '"\\EADA"',
    },
    'gas-station': {
        large: '"\\EADB"',
        small: '"\\EADC"',
    },
    'geofence-alert': {
        large: '"\\EADD"',
        small: '"\\EADE"',
    },
    geofence: {
        large: '"\\EADF"',
        small: '"\\EAE0"',
    },
    gift: {
        large: '"\\EAE1"',
        small: '"\\EAE2"',
    },
    'google-plus': {
        large: '"\\EAE3"',
        small: '"\\EAE4"',
    },
    gps: {
        large: '"\\EAE5"',
        small: '"\\EAE6"',
    },
    grab: {
        large: '"\\EAE7"',
        small: '"\\EAE8"',
    },
    'group-discussion': {
        large: '"\\EAE9"',
        small: '"\\EAEA"',
    },
    groups: {
        large: '"\\EAEB"',
        small: '"\\EAEC"',
    },
    handshake: {
        large: '"\\EAED"',
        small: '"\\EAEE"',
    },
    history: {
        large: '"\\EAEF"',
        small: '"\\EAF0"',
    },
    home: {
        large: '"\\EAF1"',
        small: '"\\EAF2"',
    },
    'honk-and-flash': {
        large: '"\\EAF3"',
        small: '"\\EAF4"',
    },
    honk: {
        large: '"\\EAF5"',
        small: '"\\EAF6"',
    },
    hotline: {
        large: '"\\EAF7"',
        small: '"\\EAF8"',
    },
    idea: {
        large: '"\\EAF9"',
        small: '"\\EAFA"',
    },
    indicators: {
        large: '"\\EAFB"',
        small: '"\\EAFC"',
    },
    inspection: {
        large: '"\\EAFD"',
        small: '"\\EAFE"',
    },
    instagram: {
        large: '"\\EAFF"',
        small: '"\\EB00"',
    },
    'interior-configuration': {
        large: '"\\EB01"',
        small: '"\\EB02"',
    },
    languages: {
        large: '"\\EB03"',
        small: '"\\EB04"',
    },
    laptop: {
        large: '"\\EB05"',
        small: '"\\EB06"',
    },
    'lights-crossed': {
        large: '"\\EB07"',
        small: '"\\EB08"',
    },
    'lights-day': {
        large: '"\\EB09"',
        small: '"\\EB0A"',
    },
    'lights-dim': {
        large: '"\\EB0B"',
        small: '"\\EB0C"',
    },
    'lights-full-beam': {
        large: '"\\EB0D"',
        small: '"\\EB0E"',
    },
    'lights-led': {
        large: '"\\EB0F"',
        small: '"\\EB10"',
    },
    'lights-xenon': {
        large: '"\\EB11"',
        small: '"\\EB12"',
    },
    line: {
        large: '"\\EB13"',
        small: '"\\EB16"',
    },
    'line-me': {
        large: '"\\EB14"',
        small: '"\\EB15"',
    },
    linkedin: {
        large: '"\\EB17"',
        small: '"\\EB18"',
    },
    list: {
        large: '"\\EB19"',
        small: '"\\EB1A"',
    },
    lock: {
        large: '"\\EB1B"',
        small: '"\\EB1C"',
    },
    'lock-unlock': {
        large: '"\\EB1D"',
        small: '"\\EB1E"',
    },
    logbook: {
        large: '"\\EB1F"',
        small: '"\\EB20"',
    },
    login: {
        large: '"\\EB21"',
        small: '"\\EB22"',
    },
    logout: {
        large: '"\\EB23"',
        small: '"\\EB24"',
    },
    'loose-wheel-indicator': {
        large: '"\\EB25"',
        small: '"\\EB26"',
    },
    'main-user': {
        large: '"\\EB27"',
        small: '"\\EB28"',
    },
    maintenance: {
        large: '"\\EB29"',
        small: '"\\EB2A"',
    },
    'maneuvering-assist': {
        large: '"\\EB2B"',
        small: '"\\EB2C"',
    },
    'map-layer': {
        large: '"\\EB2D"',
        small: '"\\EB2E"',
    },
    merchandise: {
        large: '"\\EB2F"',
        small: '"\\EB30"',
    },
    'microphone-off': {
        large: '"\\EB31"',
        small: '"\\EB32"',
    },
    'microphone-on': {
        large: '"\\EB33"',
        small: '"\\EB34"',
    },
    mileage: {
        large: '"\\EB35"',
        small: '"\\EB36"',
    },
    mmi: {
        large: '"\\EB37"',
        small: '"\\EB38"',
    },
    'mobile-phone': {
        large: '"\\EB39"',
        small: '"\\EB3A"',
    },
    more: {
        large: '"\\EB3B"',
        small: '"\\EB3C"',
    },
    motorway: {
        large: '"\\EB3D"',
        small: '"\\EB3E"',
    },
    'my-dealer': {
        large: '"\\EB3F"',
        small: '"\\EB40"',
    },
    'myaudi-destinations': {
        large: '"\\EB41"',
        small: '"\\EB42"',
    },
    napster: {
        large: '"\\EB43"',
        small: '"\\EB44"',
    },
    network: {
        large: '"\\EB45"',
        small: '"\\EB46"',
    },
    news: {
        large: '"\\EB47"',
        small: '"\\EB48"',
    },
    'nfc-inactive': {
        large: '"\\EB49"',
        small: '"\\EB4A"',
    },
    nfc: {
        large: '"\\EB4B"',
        small: '"\\EB4C"',
    },
    notepad: {
        large: '"\\EB4D"',
        small: '"\\EB4E"',
    },
    'off-canvas': {
        large: '"\\EB4F"',
        small: '"\\EB50"',
    },
    'offline-maps': {
        large: '"\\EB51"',
        small: '"\\EB52"',
    },
    'oil-change': {
        large: '"\\EB53"',
        small: '"\\EB54"',
    },
    options: {
        large: '"\\EB55"',
        small: '"\\EB56"',
    },
    'order-reverse': {
        large: '"\\EB57"',
        small: '"\\EB58"',
    },
    'over-the-air-car': {
        large: '"\\EB59"',
        small: '"\\EB5A"',
    },
    'over-the-air': {
        large: '"\\EB5B"',
        small: '"\\EB5C"',
    },
    'parking-in-left': {
        large: '"\\EB5D"',
        small: '"\\EB60"',
    },
    'parking-in-left-long': {
        large: '"\\EB5E"',
        small: '"\\EB5F"',
    },
    'parking-in-right': {
        large: '"\\EB61"',
        small: '"\\EB64"',
    },
    'parking-in-right-long': {
        large: '"\\EB62"',
        small: '"\\EB63"',
    },
    'parking-in-straight': {
        large: '"\\EB65"',
        small: '"\\EB66"',
    },
    parking: {
        large: '"\\EB67"',
        small: '"\\EB72"',
    },
    'parking-out-left': {
        large: '"\\EB68"',
        small: '"\\EB6B"',
    },
    'parking-out-left-long': {
        large: '"\\EB69"',
        small: '"\\EB6A"',
    },
    'parking-out-right': {
        large: '"\\EB6C"',
        small: '"\\EB6F"',
    },
    'parking-out-right-long': {
        large: '"\\EB6D"',
        small: '"\\EB6E"',
    },
    'parking-out-straight': {
        large: '"\\EB70"',
        small: '"\\EB71"',
    },
    pause: {
        large: '"\\EB73"',
        small: '"\\EB74"',
    },
    photo: {
        large: '"\\EB75"',
        small: '"\\EB76"',
    },
    'piloted-parking': {
        large: '"\\EB77"',
        small: '"\\EB78"',
    },
    pinterest: {
        large: '"\\EB79"',
        small: '"\\EB7A"',
    },
    'plan-route': {
        large: '"\\EB7B"',
        small: '"\\EB7C"',
    },
    play: {
        large: '"\\EB7D"',
        small: '"\\EB7E"',
    },
    'plug-ccs-dc': {
        large: '"\\EB7F"',
        small: '"\\EB80"',
    },
    'plug-ccs1': {
        large: '"\\EB81"',
        small: '"\\EB82"',
    },
    'plug-cee3': {
        large: '"\\EB83"',
        small: '"\\EB84"',
    },
    'plug-cee5': {
        large: '"\\EB85"',
        small: '"\\EB86"',
    },
    'plug-chademo-dc': {
        large: '"\\EB87"',
        small: '"\\EB88"',
    },
    'plug-schuko': {
        large: '"\\EB89"',
        small: '"\\EB8A"',
    },
    'plug-type1-ac': {
        large: '"\\EB8B"',
        small: '"\\EB8C"',
    },
    'plug-type2-ac': {
        large: '"\\EB8D"',
        small: '"\\EB8E"',
    },
    'poi-calendar': {
        large: '"\\EB8F"',
        small: '"\\EB90"',
    },
    'poi-car': {
        large: '"\\EB91"',
        small: '"\\EB92"',
    },
    'poi-contact': {
        large: '"\\EB93"',
        small: '"\\EB94"',
    },
    'poi-favorite': {
        large: '"\\EB95"',
        small: '"\\EB96"',
    },
    'poi-home': {
        large: '"\\EB97"',
        small: '"\\EB98"',
    },
    poi: {
        large: '"\\EB99"',
        small: '"\\EBA0"',
    },
    'poi-last-destination': {
        large: '"\\EB9A"',
        small: '"\\EB9B"',
    },
    'poi-on-map': {
        large: '"\\EB9C"',
        small: '"\\EB9D"',
    },
    'poi-search': {
        large: '"\\EB9E"',
        small: '"\\EB9F"',
    },
    'poi-work': {
        large: '"\\EBA1"',
        small: '"\\EBA2"',
    },
    pois: {
        large: '"\\EBA3"',
        small: '"\\EBA4"',
    },
    polls: {
        large: '"\\EBA5"',
        small: '"\\EBA6"',
    },
    power: {
        large: '"\\EBA7"',
        small: '"\\EBA8"',
    },
    'pre-heating': {
        large: '"\\EBA9"',
        small: '"\\EBAA"',
    },
    print: {
        large: '"\\EBAB"',
        small: '"\\EBAC"',
    },
    'privacy-mode': {
        large: '"\\EBAD"',
        small: '"\\EBAE"',
    },
    'private-customer': {
        large: '"\\EBAF"',
        small: '"\\EBB0"',
    },
    profile: {
        large: '"\\EBB1"',
        small: '"\\EBB2"',
    },
    projects: {
        large: '"\\EBB3"',
        small: '"\\EBB4"',
    },
    'public-transport': {
        large: '"\\EBB5"',
        small: '"\\EBB6"',
    },
    quattro: {
        large: '"\\EBB7"',
        small: '"\\EBB8"',
    },
    'rating-filled-50': {
        large: '"\\EBB9"',
        small: '"\\EBBA"',
    },
    'rating-filled': {
        large: '"\\EBBB"',
        small: '"\\EBBC"',
    },
    rating: {
        large: '"\\EBBD"',
        small: '"\\EBBE"',
    },
    'receive-e-mail-notification': {
        large: '"\\EBBF"',
        small: '"\\EBC0"',
    },
    'recommended-destination': {
        large: '"\\EBC1"',
        small: '"\\EBC2"',
    },
    refresh: {
        large: '"\\EBC3"',
        small: '"\\EBC4"',
    },
    replay: {
        large: '"\\EBC5"',
        small: '"\\EBC6"',
    },
    'resize-decrease': {
        large: '"\\EBC7"',
        small: '"\\EBC8"',
    },
    'resize-increase': {
        large: '"\\EBC9"',
        small: '"\\EBCA"',
    },
    restaurant: {
        large: '"\\EBCB"',
        small: '"\\EBCC"',
    },
    restroom: {
        large: '"\\EBCD"',
        small: '"\\EBCE"',
    },
    'results-list': {
        large: '"\\EBCF"',
        small: '"\\EBD0"',
    },
    'roof-open': {
        large: '"\\EBD1"',
        small: '"\\EBD2"',
    },
    'rotate-device': {
        large: '"\\EBD3"',
        small: '"\\EBD4"',
    },
    'rotate-image-left': {
        large: '"\\EBD5"',
        small: '"\\EBD6"',
    },
    'rotate-image-right': {
        large: '"\\EBD7"',
        small: '"\\EBD8"',
    },
    'rotate-left': {
        large: '"\\EBD9"',
        small: '"\\EBDA"',
    },
    'rotate-right': {
        large: '"\\EBDB"',
        small: '"\\EBDC"',
    },
    'roundabout-left': {
        large: '"\\EBDD"',
        small: '"\\EBDE"',
    },
    'roundabout-long-left': {
        large: '"\\EBDF"',
        small: '"\\EBE0"',
    },
    'roundabout-long-right': {
        large: '"\\EBE1"',
        small: '"\\EBE2"',
    },
    'roundabout-right': {
        large: '"\\EBE3"',
        small: '"\\EBE4"',
    },
    'roundabout-sharp-left': {
        large: '"\\EBE5"',
        small: '"\\EBE6"',
    },
    'roundabout-sharp-right': {
        large: '"\\EBE7"',
        small: '"\\EBE8"',
    },
    'roundabout-straight': {
        large: '"\\EBE9"',
        small: '"\\EBEA"',
    },
    search: {
        large: '"\\EBEB"',
        small: '"\\EBEC"',
    },
    'select-all': {
        large: '"\\EBED"',
        small: '"\\EBEE"',
    },
    select: {
        large: '"\\EBEF"',
        small: '"\\EBF0"',
    },
    send: {
        large: '"\\EBF1"',
        small: '"\\EBF2"',
    },
    'send-to-vehicle': {
        large: '"\\EBF3"',
        small: '"\\EBF4"',
    },
    settings: {
        large: '"\\EBF5"',
        small: '"\\EBF6"',
    },
    'share-android': {
        large: '"\\EBF7"',
        small: '"\\EBF8"',
    },
    share: {
        large: '"\\EBF9"',
        small: '"\\EBFA"',
    },
    'shopping-basket': {
        large: '"\\EBFB"',
        small: '"\\EBFC"',
    },
    shuffle: {
        large: '"\\EBFD"',
        small: '"\\EBFE"',
    },
    'side-assist': {
        large: '"\\EBFF"',
        small: '"\\EC00"',
    },
    signal: {
        large: '"\\EC01"',
        small: '"\\EC02"',
    },
    'skip-next': {
        large: '"\\EC03"',
        small: '"\\EC04"',
    },
    'skip-previous': {
        large: '"\\EC05"',
        small: '"\\EC06"',
    },
    slider: {
        large: '"\\EC07"',
        small: '"\\EC08"',
    },
    smartwatch: {
        large: '"\\EC09"',
        small: '"\\EC0A"',
    },
    'smiley-happy': {
        large: '"\\EC0B"',
        small: '"\\EC0C"',
    },
    'smiley-neutral': {
        large: '"\\EC0D"',
        small: '"\\EC0E"',
    },
    'smiley-unhappy': {
        large: '"\\EC0F"',
        small: '"\\EC10"',
    },
    snapchat: {
        large: '"\\EC11"',
        small: '"\\EC12"',
    },
    'social-reader': {
        large: '"\\EC13"',
        small: '"\\EC14"',
    },
    'spark-plug': {
        large: '"\\EC15"',
        small: '"\\EC16"',
    },
    'special-offer': {
        large: '"\\EC17"',
        small: '"\\EC18"',
    },
    split: {
        large: '"\\EC19"',
        small: '"\\EC1A"',
    },
    'status-update': {
        large: '"\\EC1B"',
        small: '"\\EC1C"',
    },
    sync: {
        large: '"\\EC1D"',
        small: '"\\EC20"',
    },
    'sync-off': {
        large: '"\\EC1E"',
        small: '"\\EC1F"',
    },
    'system-add': {
        large: '"\\EC21"',
        small: '"\\EC22"',
    },
    'system-audio-off': {
        large: '"\\EC23"',
        small: '"\\EC24"',
    },
    'system-audio-on': {
        large: '"\\EC25"',
        small: '"\\EC26"',
    },
    'system-cancel': {
        large: '"\\EC27"',
        small: '"\\EC28"',
    },
    'system-code': {
        large: '"\\EC29"',
        small: '"\\EC2A"',
    },
    'system-compare': {
        large: '"\\EC2B"',
        small: '"\\EC2C"',
    },
    'system-download': {
        large: '"\\EC2D"',
        small: '"\\EC2E"',
    },
    'system-facebook': {
        large: '"\\EC2F"',
        small: '"\\EC30"',
    },
    'system-favorites': {
        large: '"\\EC31"',
        small: '"\\EC32"',
    },
    'system-follow': {
        large: '"\\EC33"',
        small: '"\\EC34"',
    },
    'system-google-plus': {
        large: '"\\EC35"',
        small: '"\\EC36"',
    },
    'system-help': {
        large: '"\\EC37"',
        small: '"\\EC38"',
    },
    'system-info': {
        large: '"\\EC39"',
        small: '"\\EC3A"',
    },
    'system-instagram': {
        large: '"\\EC3B"',
        small: '"\\EC3C"',
    },
    'system-line-me': {
        large: '"\\EC3D"',
        small: '"\\EC3E"',
    },
    'system-linkedin': {
        large: '"\\EC3F"',
        small: '"\\EC40"',
    },
    'system-paragraph': {
        large: '"\\EC41"',
        small: '"\\EC42"',
    },
    'system-pause': {
        large: '"\\EC43"',
        small: '"\\EC44"',
    },
    'system-pinterest': {
        large: '"\\EC45"',
        small: '"\\EC46"',
    },
    'system-play-backwards': {
        large: '"\\EC47"',
        small: '"\\EC48"',
    },
    'system-play': {
        large: '"\\EC49"',
        small: '"\\EC4A"',
    },
    'system-print': {
        large: '"\\EC4B"',
        small: '"\\EC4C"',
    },
    'system-remove': {
        large: '"\\EC4D"',
        small: '"\\EC4E"',
    },
    'system-replay': {
        large: '"\\EC4F"',
        small: '"\\EC50"',
    },
    'system-resize-decrease': {
        large: '"\\EC51"',
        small: '"\\EC52"',
    },
    'system-resize-increase': {
        large: '"\\EC53"',
        small: '"\\EC54"',
    },
    'system-save-as': {
        large: '"\\EC55"',
        small: '"\\EC56"',
    },
    'system-search': {
        large: '"\\EC57"',
        small: '"\\EC58"',
    },
    'system-select': {
        large: '"\\EC59"',
        small: '"\\EC5A"',
    },
    'system-settings': {
        large: '"\\EC5B"',
        small: '"\\EC5C"',
    },
    'system-share-android': {
        large: '"\\EC5D"',
        small: '"\\EC5E"',
    },
    'system-share': {
        large: '"\\EC5F"',
        small: '"\\EC60"',
    },
    'system-skip-next': {
        large: '"\\EC61"',
        small: '"\\EC62"',
    },
    'system-skip-previous': {
        large: '"\\EC63"',
        small: '"\\EC64"',
    },
    'system-snapchat': {
        large: '"\\EC65"',
        small: '"\\EC66"',
    },
    'system-sync': {
        large: '"\\EC67"',
        small: '"\\EC68"',
    },
    'system-twitter': {
        large: '"\\EC69"',
        small: '"\\EC6A"',
    },
    'system-upload': {
        large: '"\\EC6B"',
        small: '"\\EC6C"',
    },
    'system-vimeo': {
        large: '"\\EC6D"',
        small: '"\\EC6E"',
    },
    'system-wechat': {
        large: '"\\EC6F"',
        small: '"\\EC70"',
    },
    'system-weibo': {
        large: '"\\EC71"',
        small: '"\\EC72"',
    },
    'system-whatsapp': {
        large: '"\\EC73"',
        small: '"\\EC74"',
    },
    'system-xing': {
        large: '"\\EC75"',
        small: '"\\EC76"',
    },
    'system-yelp': {
        large: '"\\EC77"',
        small: '"\\EC78"',
    },
    'system-youku': {
        large: '"\\EC79"',
        small: '"\\EC7A"',
    },
    'system-youtube': {
        large: '"\\EC7B"',
        small: '"\\EC7C"',
    },
    'system-zhihu': {
        large: '"\\EC7D"',
        small: '"\\EC7E"',
    },
    tag: {
        large: '"\\EC7F"',
        small: '"\\EC80"',
    },
    'test-drive': {
        large: '"\\EC81"',
        small: '"\\EC82"',
    },
    'thumbs-down': {
        large: '"\\EC83"',
        small: '"\\EC84"',
    },
    'thumbs-up': {
        large: '"\\EC85"',
        small: '"\\EC86"',
    },
    'time-climate1': {
        large: '"\\EC87"',
        small: '"\\EC88"',
    },
    'time-climate2': {
        large: '"\\EC89"',
        small: '"\\EC8A"',
    },
    time: {
        large: '"\\EC8B"',
        small: '"\\EC92"',
    },
    'time-long': {
        large: '"\\EC8C"',
        small: '"\\EC8D"',
    },
    'time-middle': {
        large: '"\\EC8E"',
        small: '"\\EC8F"',
    },
    'time-short': {
        large: '"\\EC90"',
        small: '"\\EC91"',
    },
    'tire-battery': {
        large: '"\\EC93"',
        small: '"\\EC94"',
    },
    tire: {
        large: '"\\EC95"',
        small: '"\\EC98"',
    },
    'tire-sealant': {
        large: '"\\EC96"',
        small: '"\\EC97"',
    },
    'top-speed': {
        large: '"\\EC99"',
        small: '"\\EC9A"',
    },
    torque: {
        large: '"\\EC9B"',
        small: '"\\EC9C"',
    },
    tour: {
        large: '"\\EC9D"',
        small: '"\\EC9E"',
    },
    traffic: {
        large: '"\\EC9F"',
        small: '"\\ECA4"',
    },
    'traffic-sign-recognition-alert': {
        large: '"\\ECA0"',
        small: '"\\ECA1"',
    },
    'traffic-sign-recognition': {
        large: '"\\ECA2"',
        small: '"\\ECA3"',
    },
    'trailer-maneuver': {
        large: '"\\ECA5"',
        small: '"\\ECA6"',
    },
    train: {
        large: '"\\ECA7"',
        small: '"\\ECA8"',
    },
    training: {
        large: '"\\ECA9"',
        small: '"\\ECAA"',
    },
    transmission: {
        large: '"\\ECAB"',
        small: '"\\ECAC"',
    },
    'trunk-open': {
        large: '"\\ECAD"',
        small: '"\\ECAE"',
    },
    tube: {
        large: '"\\ECAF"',
        small: '"\\ECB0"',
    },
    twitter: {
        large: '"\\ECB1"',
        small: '"\\ECB2"',
    },
    upload: {
        large: '"\\ECB3"',
        small: '"\\ECB4"',
    },
    'used-car-search': {
        large: '"\\ECB5"',
        small: '"\\ECB6"',
    },
    'used-cars': {
        large: '"\\ECB7"',
        small: '"\\ECB8"',
    },
    user: {
        large: '"\\ECB9"',
        small: '"\\ECBA"',
    },
    'user-whole-body': {
        large: '"\\ECBB"',
        small: '"\\ECBC"',
    },
    'valet-parking': {
        large: '"\\ECBD"',
        small: '"\\ECBE"',
    },
    'vehicle-signal': {
        large: '"\\ECBF"',
        small: '"\\ECC0"',
    },
    'vehicle-wi-fi-1': {
        large: '"\\ECC1"',
        small: '"\\ECC2"',
    },
    'vehicle-wi-fi-2': {
        large: '"\\ECC3"',
        small: '"\\ECC4"',
    },
    'vehicle-wi-fi-3': {
        large: '"\\ECC5"',
        small: '"\\ECC6"',
    },
    'vehicle-wi-fi-4': {
        large: '"\\ECC7"',
        small: '"\\ECC8"',
    },
    'velocity-alert': {
        large: '"\\ECC9"',
        small: '"\\ECCA"',
    },
    velocity: {
        large: '"\\ECCB"',
        small: '"\\ECCC"',
    },
    'video-call': {
        large: '"\\ECCD"',
        small: '"\\ECCE"',
    },
    video: {
        large: '"\\ECCF"',
        small: '"\\ECD0"',
    },
    'view-360': {
        large: '"\\ECD1"',
        small: '"\\ECD2"',
    },
    vimeo: {
        large: '"\\ECD3"',
        small: '"\\ECD4"',
    },
    'voice-call-1': {
        large: '"\\ECD5"',
        small: '"\\ECD6"',
    },
    'voice-call-2': {
        large: '"\\ECD7"',
        small: '"\\ECD8"',
    },
    'voice-call-3': {
        large: '"\\ECD9"',
        small: '"\\ECDA"',
    },
    'voice-call': {
        large: '"\\ECDB"',
        small: '"\\ECDC"',
    },
    walk: {
        large: '"\\ECDD"',
        small: '"\\ECDE"',
    },
    wallbox: {
        large: '"\\ECDF"',
        small: '"\\ECE0"',
    },
    warranty: {
        large: '"\\ECE1"',
        small: '"\\ECE2"',
    },
    weblink: {
        large: '"\\ECE3"',
        small: '"\\ECE4"',
    },
    wechat: {
        large: '"\\ECE5"',
        small: '"\\ECE6"',
    },
    weibo: {
        large: '"\\ECE7"',
        small: '"\\ECE8"',
    },
    whatsapp: {
        large: '"\\ECE9"',
        small: '"\\ECEA"',
    },
    work: {
        large: '"\\ECEB"',
        small: '"\\ECEC"',
    },
    xing: {
        large: '"\\ECED"',
        small: '"\\ECEE"',
    },
    yelp: {
        large: '"\\ECEF"',
        small: '"\\ECF0"',
    },
    youku: {
        large: '"\\ECF1"',
        small: '"\\ECF2"',
    },
    youtube: {
        large: '"\\ECF3"',
        small: '"\\ECF4"',
    },
    zhihu: {
        large: '"\\ECF5"',
        small: '"\\ECF6"',
    },
};
export const iconsNames = Object.keys(convertedIcons);
export const getIconChar = (iconName, size) => {
    return convertedIcons[iconName][size];
};
//# sourceMappingURL=IconsNames.mjs.mjs.map